import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import EstacionamientoService from "../../services/EstacionamientoService";
import { useNavigate, NavLink } from "react-router-dom";

function Clock(){

  const navigate = useNavigate();
  const [date, setDate] = useState(new Date());
  const iniDate =  new Date(date.getFullYear()
  ,parseInt(localStorage.getItem("estacionamiento_horaini").substring(3,5))-1
  ,parseInt(localStorage.getItem("estacionamiento_horaini").substring(0,2))
  ,parseInt(localStorage.getItem("estacionamiento_horaini").substring(6,8)),
  parseInt(localStorage.getItem("estacionamiento_horaini").substring(9,11)),0)
  
  
  
    const differenceInSeconds = (a, b) => 
    { return Math.floor((a.getTime() - b.getTime())/ (1000 * 60) );
    }
    
  
    function refreshClock() {
      EstacionamientoService.consultarEstado(localStorage.getItem("estacionamiento_celular"), localStorage.getItem("estacionamiento_token"))
      .then ((resp)=>{
        if (resp.data.errorCode=="2" || resp.data.errorCode=="77" ) {
          setDate(new Date())
         }
         else {

          navigate("/estacionamientofin");
         }
      })
      .catch((error)=>{
        console.log(error);
        navigate("/estacionamientofin");
      });
  }
  useEffect(() => {
    const timerId = setInterval(refreshClock, 1000 * 60);
    return function cleanup() {
      clearInterval(timerId);
    };
  }, []);
  return (
    <span>
      {differenceInSeconds(date, iniDate)}
    </span>
  );
}
export default Clock;